import i18n from 'services/base/i18n';

export default {
  profilePassiveName: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Passive|Name',
    'Passive'
  ),
  profilePassiveSummary: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Passive|Summary',
    'Passively intercept all network traffic passing through the Pangolin\'s physical ports.'
  ),
  profilePassiveDetails: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Passive|Details',
    'Passively intercept all network traffic passing through the Pangolin\'s physical ports.\n\nThis allows the Pangolin to monitor and control all network traffic that physically passes through its ethernet ports.\n\nThis mode cannot see traffic between network segments that the Pangolin does not physically separate.\n\nSuitable for medium to large networks.\n\nThis mode has better compatibility with complex network setups, other network security controls, and modern operating systems that protect against ARP spoofing like Android and iOS.'
  ),
  profilePassiveGuide: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Passive|Guide',
    'Connect the WAN port of the Pangolin to your router, and its LAN ports to segments of your network that you want to protect.'
  ),
  profilePassiveWarning: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Passive|Warning',
    'Only network traffic passing through the Pangolin can be analyzed. See above to find out which traffic flow scenarios are covered.'
  ),

  profileActiveFullName: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Full|Name',
    'Active - Full'
  ),
  profileActiveFullSummary: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Full|Summary',
    'Actively redirect all network traffic to the Pangolin using ARP spoofing.'
  ),
  profileActiveFullDetails: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Full|Details',
    'Actively redirect all network traffic to the Pangolin using ARP spoofing.\n\nThis allows the Pangolin to monitor and control all network traffic without being deployed inline.\n\nThis is the most comprehensive interception mode, but it is also the most resource-intensive and may result in slowdowns if you have a large network.\n\nUse only in small simple networks with no other network security controls.\n\nActive traffic redirection may possibly conflict with complex network setups, other network security controls, and modern operating systems that protect against ARP spoofing like Android and iOS.'
  ),
  profileActiveFullGuide: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Full|Guide',
    'Connect the WAN port of the Pangolin to your router. It will actively redirect all traffic to itself using ARP spoofing.'
  ),
  profileActiveFullWarning: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Full|Warning',
    'This mode may conflict with complex network setups, other network security controls, and modern operating systems.'
  ),

  profileActiveInternetName: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Internet|Name',
    'Active - Internet'
  ),
  profileActiveInternetSummary: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Internet|Summary',
    'Actively redirect only internet traffic to the Pangolin using ARP spoofing.'
  ),
  profileActiveInternetDetails: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Internet|Details',
    'Actively redirect only internet traffic to the Pangolin using ARP spoofing.\n\nThis allows the Pangolin to monitor and control only internet traffic without being deployed inline.\n\nThis mode cannot see traffic between internal network devices, but it is more efficient and may result in better performance than full redirection.\n\nUse only in small simple networks with no other network security controls.\n\nActive traffic redirection may possibly conflict with complex network setups, other network security controls, and modern operating systems that protect against ARP spoofing like Android and iOS.'
  ),
  profileActiveInternetGuide: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Internet|Guide',
    'Connect the WAN port of the Pangolin to your router. It will actively redirect internet traffic to itself using ARP spoofing.'
  ),
  profileActiveInternetWarning: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Active - Internet|Warning',
    'This mode may conflict with complex network setups, other network security controls, and modern operating systems.'
  ),

  profileCustomName: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Custom|Name',
    'Custom'
  ),
  profileCustomSummary: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Custom|Summary',
    'Your settings do not match any of the pre-defined deployment profiles.'
  ),
  profileCustomDetails: () => i18n.pgettext(
    'Enums|Deployment Profiles|Profiles|Custom|Details',
    'Your settings do not match any of the pre-defined deployment profiles.\n\nPangolin behavior may be unpredictable. Use with caution.'
  ),
};
